import { atom } from "recoil";

const priceState =atom({
    key: 'price',
    default: 0
})

export default priceState